/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Join_HappyInputs */

const en_auth_join_happy = /** @type {(inputs: Auth_Join_HappyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`happy Listening users`)
};

const es_auth_join_happy = /** @type {(inputs: Auth_Join_HappyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`usuarios felices de Listening`)
};

/**
* | output |
* | --- |
* | "happy Listening users" |
*
* @param {Auth_Join_HappyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_join_happy = /** @type {((inputs?: Auth_Join_HappyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Join_HappyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_join_happy(inputs)
	return en_auth_join_happy(inputs)
});